var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSellLand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "#007ED9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "item"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M2.5 8.81722L8.91533 3.31824C9.53949 2.78324 10.4605 2.78324 11.0847 3.31824L17.5 8.81722",
    stroke: "inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M9.16667 17.4997H2.5",
    stroke: "inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M13.0195 4.97652V3.125C13.0195 2.77982 13.2994 2.5 13.6445 2.5H15.8036C16.1488 2.5 16.4286 2.77982 16.4286 3.125V7.89866",
    stroke: "inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M3.57096 7.89844V17.4998",
    stroke: "inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8889 10.833H11.823C11.2762 10.833 10.833 11.2763 10.833 11.8231V13.8885C10.8333 14.1513 10.9381 14.4033 11.1242 14.5889L13.7448 17.2097C14.1316 17.5963 14.7585 17.5963 15.1453 17.2097L17.2098 15.1458C17.5963 14.7589 17.5963 14.132 17.2098 13.7451L14.5892 11.1242C14.4036 10.9381 14.1517 10.8333 13.8889 10.833V10.833Z",
    stroke: "inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M12.9432 12.9432C12.9287 12.9577 12.9288 12.9812 12.9432 12.9956C12.9577 13.0101 12.9811 13.0101 12.9956 12.9956C13.0101 12.9811 13.0101 12.9577 12.9956 12.9432C12.9812 12.9288 12.9577 12.9287 12.9432 12.9432L12.9432 12.9432",
    stroke: "inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellLand);
export default __webpack_public_path__ + "static/media/sell_land.fa757cb644d20225ea1fb1084a7af16e.svg";
export { ForwardRef as ReactComponent };